(() => {
  const bar = document.querySelector('[data-pq-mobile-buy-bar]');
  const host = document.querySelector('product-info');
  const sheet = host && host.querySelector('[data-pq-mobile-buy-sheet]');
  if (!bar || !host) return;

  const button = bar.querySelector('[data-pq-mobile-buy-bar-button]');
  const label = bar.querySelector('[data-pq-mobile-buy-bar-label]');
  const spinner = bar.querySelector('.loading__spinner');
  const vueRoot = host.querySelector('.v-section');
  const panel = sheet && sheet.querySelector('.pq-mobile-buy-sheet__panel');
  const sheetImage = sheet && sheet.querySelector('[data-pq-mobile-buy-sheet-image]');
  const headerZoom = sheet && sheet.querySelector('.pq-mobile-buy-sheet__thumb-zoom');
  const overlay = document.querySelector('[data-pq-mobile-buy-overlay]');
  const mediaQuery = window.matchMedia('(max-width: 749px)');
  const nativeParkNames = ['options', 'qty', 'submit'];
  const customParkNames = ['vue-options', 'vue-submit'];
  const qtySlot = sheet && sheet.querySelector('[data-pq-park-slot="qty"]');

  const fitQtyInput = (input) => {
    if (!input) return;
    const chars = String(input.value ?? '').replace(/\D/g, '').length || 1;
    input.style.setProperty('--pq-qty-chars', String(chars));
  };

  const syncQtyInputWidth = () => {
    const root = qtySlot || host;
    fitQtyInput(root.querySelector('.quantity__input[name="quantity"]'));
  };

  let sheetOpen = false;
  let closeTimer = 0;
  const closeDuration = 400;

  const setSupportHidden = (key, hidden) => {
    const api = window.PqSupportVisibility;
    if (!api) return;
    if (hidden) api.hide(key);
    else api.show(key);
  };

  const syncProductModalSupport = () => {
    if (!mediaQuery.matches) {
      setSupportHidden('product-modal', false);
      return;
    }
    const sectionId = host.dataset.section;
    if (!sectionId) {
      setSupportHidden('product-modal', false);
      return;
    }
    const escaped = window.CSS && CSS.escape ? CSS.escape(sectionId) : sectionId;
    const open = document.querySelector(
      `modal-dialog[data-section="${escaped}"][open], product-modal[data-section="${escaped}"][open]`
    );
    setSupportHidden('product-modal', Boolean(open));
  };

  const prefersReducedMotion = () =>
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const findSourceButton = () => {
    const nativeWrapper = host.querySelector('#buy-buttons');
    if (nativeWrapper && !nativeWrapper.classList.contains('hidden')) {
      return nativeWrapper.querySelector('.product-form__submit');
    }
    return host.querySelector(
      '[data-pq-park-slot="vue-submit"] .product-form__submit, [data-pq-park-home="vue-submit"] .product-form__submit'
    );
  };

  const isNativeBuy = () => {
    const nativeWrapper = host.querySelector('#buy-buttons');
    return Boolean(nativeWrapper && !nativeWrapper.classList.contains('hidden'));
  };

  const updateOffset = () => {
    const height = bar.hidden || sheetOpen ? 0 : bar.offsetHeight;
    document.documentElement.style.setProperty('--pq-mobile-buy-bar-height', `${height}px`);
  };

  const setLoading = (loading) => {
    button.classList.toggle('loading', loading);
    if (spinner) spinner.classList.toggle('hidden', !loading);
    if (loading) {
      button.setAttribute('aria-busy', 'true');
    } else {
      button.removeAttribute('aria-busy');
    }
  };

  let variantPending = false;
  let variantPendingTimer = 0;

  const setNativeSubmitLoading = (loading) => {
    if (!isNativeBuy()) return;
    const source = findSourceButton();
    if (!source) return;
    source.classList.toggle('loading', loading);
    const spin = source.querySelector('.loading__spinner');
    if (spin) spin.classList.toggle('hidden', !loading);
  };

  const endVariantPending = () => {
    if (variantPendingTimer) {
      window.clearTimeout(variantPendingTimer);
      variantPendingTimer = 0;
    }
    if (!variantPending) return;
    variantPending = false;
    setNativeSubmitLoading(false);
    schedule();
  };

  const beginVariantPending = () => {
    if (!isNativeBuy()) return;
    variantPending = true;
    if (variantPendingTimer) window.clearTimeout(variantPendingTimer);
    variantPendingTimer = window.setTimeout(endVariantPending, 8000);
    setNativeSubmitLoading(true);
  };

  const parkNode = (name, toSheet) => {
    if (!sheet) return;
    const home = host.querySelector(`[data-pq-park-home="${name}"]`);
    const slot = sheet.querySelector(`[data-pq-park-slot="${name}"]`);
    if (!home || !slot) return;
    const node = home.firstElementChild || slot.firstElementChild;
    if (!node) return;
    const dest = toSheet ? slot : home;
    if (node.parentNode !== dest) dest.appendChild(node);
  };

  const syncPark = () => {
    if (!sheet) return;
    const toSheet = mediaQuery.matches;
    const native = isNativeBuy();
    nativeParkNames.forEach((name) => parkNode(name, toSheet && native));
    customParkNames.forEach((name) => parkNode(name, toSheet && !native));
    sheet.classList.toggle('pq-mobile-buy-sheet--custom', toSheet && !native);
  };

  const optionsSlot = sheet && sheet.querySelector('.pq-mobile-buy-sheet__options');
  let optionsScrollTop = 0;

  const saveOptionsScroll = () => {
    if (optionsSlot) optionsScrollTop = optionsSlot.scrollTop;
  };

  const restoreOptionsScroll = () => {
    if (!optionsSlot) return;
    optionsSlot.scrollTop = optionsScrollTop;
  };

  const restoreOptionsScrollSoon = () => {
    restoreOptionsScroll();
    requestAnimationFrame(() => {
      restoreOptionsScroll();
      requestAnimationFrame(restoreOptionsScroll);
    });
  };

  const pruneStalePickers = () => {
    if (!optionsSlot) return;
    const pickers = Array.from(optionsSlot.querySelectorAll('variant-selects'));
    if (pickers.length < 2) return;
    const live = pickers.find((picker) => picker.style.display !== 'none') || pickers[0];
    pickers.forEach((picker) => {
      if (picker !== live) picker.remove();
    });
    restoreOptionsScroll();
  };

  const decorateOptionLayouts = () => {
    if (!sheet) return;
    pruneStalePickers();
    sheet.querySelectorAll('fieldset.product-form__input').forEach((fieldset) => {
      const srcs = new Set(
        Array.from(fieldset.querySelectorAll('.pq-option-media img'))
          .map((img) => img.getAttribute('src'))
          .filter(Boolean)
      );
      fieldset.classList.toggle('pq-option-cards', srcs.size > 1);
    });
    syncOptionBadgeMarquee();
  };

  const syncOptionBadgeMarquee = () => {
    if (!sheet) return;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    sheet.querySelectorAll('.pq-option-badge').forEach((badge) => {
      const track = badge.querySelector('.pq-option-badge__track');
      const text = track && track.querySelector('.pq-option-badge__text');
      if (!track || !text) return;
      if (badge.getClientRects().length === 0) return;

      const copies = track.querySelectorAll('.pq-option-badge__text');
      const marquee = badge.classList.contains('is-marquee') && copies.length === 2;
      const horizontalPadding = (element) => {
        const styles = window.getComputedStyle(element);
        return (parseFloat(styles.paddingLeft) || 0) + (parseFloat(styles.paddingRight) || 0);
      };
      const contentWidth = text.scrollWidth - horizontalPadding(text);
      const visibleWidth = badge.clientWidth - horizontalPadding(badge);
      const overflow = contentWidth > visibleWidth + 1;

      if (reduceMotion || !overflow) {
        if (!marquee && copies.length === 1) return;
        copies.forEach((node, index) => {
          if (index > 0) node.remove();
        });
        badge.classList.remove('is-marquee');
        badge.style.removeProperty('--pq-badge-duration');
        return;
      }

      if (marquee) return;

      const clone = text.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
      badge.classList.add('is-marquee');
      badge.style.setProperty('--pq-badge-duration', `${Math.max(8, text.scrollWidth / 14)}s`);
    });
  };

  const selectedVariant = () => {
    const json = host.querySelector('variant-selects [data-selected-variant]');
    if (!json || !json.textContent) return null;
    try {
      return JSON.parse(json.textContent);
    } catch (error) {
      return null;
    }
  };

  const qtyInput = () =>
    (qtySlot && qtySlot.querySelector('.quantity__input[name="quantity"]')) ||
    host.querySelector('.quantity__input[name="quantity"]');

  const currentQty = () => {
    const qty = parseInt(qtyInput()?.value, 10);
    return Number.isFinite(qty) && qty > 0 ? qty : 1;
  };

  const parseMoneyAmount = (amountText) => {
    const text = String(amountText || '').trim();
    const match = text.match(/^([^\d-]*)(-?[\d.,]+)(.*)$/);
    if (!match) return null;
    const prefix = match[1];
    const numeric = match[2];
    const suffix = match[3];
    let normalized = numeric;
    const lastComma = normalized.lastIndexOf(',');
    const lastDot = normalized.lastIndexOf('.');
    if (lastComma !== -1 && lastDot !== -1) {
      normalized =
        lastComma > lastDot
          ? normalized.replace(/\./g, '').replace(',', '.')
          : normalized.replace(/,/g, '');
    } else if (lastComma !== -1) {
      const fraction = normalized.length - lastComma - 1;
      normalized = fraction <= 2 ? normalized.replace(',', '.') : normalized.replace(/,/g, '');
    }
    const value = parseFloat(normalized);
    if (!Number.isFinite(value)) return null;
    const decimals = (normalized.split('.')[1] || '').length || 2;
    const thousands = lastComma !== -1 && (lastDot === -1 ? numeric.split(',')[1].length > 2 : lastDot > lastComma);
    return {
      prefix,
      suffix,
      decimals,
      thousands,
      cents: Math.round(value * Math.pow(10, decimals)),
    };
  };

  const formatMoneyAmount = (cents, money) => {
    const value = cents / Math.pow(10, money.decimals);
    let [intPart, frac = ''] = value.toFixed(money.decimals).split('.');
    if (money.thousands) intPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const number = money.decimals ? `${intPart}.${frac}` : intPart;
    return `${money.prefix}${number}${money.suffix}`;
  };

  const splitMoneyText = (text) => {
    const normalized = String(text || '')
      .replace(/\u00a0/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
    const suffix = normalized.match(/^(.*)\s+([A-Z]{3})$/);
    if (suffix) return { amount: suffix[1].trim(), currency: suffix[2] };
    const prefix = normalized.match(/^([A-Z]{3})\s+(.*)$/);
    if (prefix) return { amount: prefix[2].trim(), currency: prefix[1] };
    return { amount: normalized, currency: '' };
  };

  const sheetPrice = sheet && sheet.querySelector('[data-pq-sheet-price]');
  const sheetMoney = (() => {
    const sample = sheetPrice?.dataset.pqMoneySample || '';
    const { amount, currency } = splitMoneyText(sample);
    const parsed = parseMoneyAmount(amount);
    return {
      prefix: parsed?.prefix || '',
      suffix: parsed?.suffix || '',
      decimals: parsed?.decimals ?? 2,
      thousands: Boolean(parsed?.thousands),
      currency,
    };
  })();

  const fillSheetLine = (root, cents) => {
    if (!root) return;
    const amountEl = root.querySelector('.pq-price-amount');
    const currencyEl = root.querySelector('.pq-price-currency');
    if (amountEl) amountEl.textContent = formatMoneyAmount(cents, sheetMoney);
    if (currencyEl) {
      currencyEl.textContent = sheetMoney.currency || '';
      currencyEl.hidden = !sheetMoney.currency;
    }
  };

  const decoratePrice = (variant) => {
    if (!sheet || !sheetPrice) return;
    const current = variant || selectedVariant();
    const saleCents = Number(current?.price ?? sheetPrice.dataset.pqSaleCents);
    if (!Number.isFinite(saleCents)) return;

    const qty = currentQty();
    fillSheetLine(sheetPrice.querySelector('[data-pq-sheet-sale]'), saleCents * qty);

    const compareEl = sheetPrice.querySelector('[data-pq-sheet-compare]');
    const compareCents = Number(
      current ? current.compare_at_price : sheetPrice.dataset.pqCompareCents
    );
    const showCompare = Number.isFinite(compareCents) && compareCents > saleCents;
    if (compareEl) {
      compareEl.hidden = !showCompare;
      if (showCompare) fillSheetLine(compareEl, compareCents * qty);
    }
  };

  const applyPriceTotals = () => decoratePrice();

  const updateSheetMedia = (variant) => {
    if (!sheetImage) return;
    const src = variant?.featured_media?.preview_image?.src;
    if (!src) return;
    sheetImage.src = src;
    sheetImage.dataset.pqPreviewSrc = src;
    sheetImage.hidden = false;
    if (headerZoom) {
      headerZoom.hidden = false;
      headerZoom.dataset.pqPreview = src;
    }
    if (window.PqMobilePreview) window.PqMobilePreview.warm(src);
  };

  const closeMobilePreview = () => {
    if (window.PqMobilePreview) window.PqMobilePreview.close();
  };

  const finishClose = () => {
    if (closeTimer) {
      window.clearTimeout(closeTimer);
      closeTimer = 0;
    }
    if (sheetOpen) return;
    setSupportHidden('product-sheet', false);
    closeMobilePreview();
    sheet.hidden = true;
    if (overlay) {
      overlay.classList.remove('is-open');
      overlay.hidden = true;
    }
    document.body.classList.remove('pq-mobile-buy-sheet-open');
    if (typeof removeTrapFocus === 'function') removeTrapFocus(button);
    updateOffset();
  };

  const closeSheet = () => {
    if (!sheet || !sheetOpen) return;
    sheetOpen = false;
    closeMobilePreview();
    sheet.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    if (typeof removeTrapFocus === 'function') removeTrapFocus(button);
    updateOffset();

    if (!panel || prefersReducedMotion()) {
      finishClose();
      return;
    }

    const onEnd = (event) => {
      if (event.target !== panel) return;
      panel.removeEventListener('transitionend', onEnd);
      finishClose();
    };
    panel.addEventListener('transitionend', onEnd);
    closeTimer = window.setTimeout(() => {
      panel.removeEventListener('transitionend', onEnd);
      finishClose();
    }, closeDuration);
  };

  const readZoomImageOptionLevel = () => {
    const root =
      host.querySelector('[data-pq-park-home="vue-options"]') ||
      optionsSlot?.querySelector('[data-pq-zoom-image-level]');
    if (!root) return null;
    const raw = root.getAttribute('data-pq-zoom-image-level');
    if (raw == null || raw === '') return null;
    const n = parseInt(raw, 10);
    return Number.isFinite(n) && n >= 1 ? n : null;
  };

  const activeOptionImage = (levelEl) =>
    levelEl?.querySelector('.option.active img')?.getAttribute('src') || '';

  const updateCustomSheetMedia = () => {
    if (!sheetImage || isNativeBuy()) return;
    const levels = Array.from(
      optionsSlot?.querySelectorAll('.variant-selector .level') || []
    );
    const configured = readZoomImageOptionLevel();
    let src = '';
    if (configured) {
      src = activeOptionImage(levels[configured - 1]);
    } else {
      for (let i = 0; i < levels.length; i += 1) {
        src = activeOptionImage(levels[i]);
        if (src) break;
      }
    }
    if (!src) return;
    sheetImage.src = src;
    sheetImage.dataset.pqPreviewSrc = src;
    sheetImage.hidden = false;
    if (headerZoom) {
      headerZoom.hidden = false;
      headerZoom.dataset.pqPreview = src;
    }
    if (window.PqMobilePreview) window.PqMobilePreview.warm(src);
  };

  const openSheet = () => {
    if (!sheet || !mediaQuery.matches) return;
    if (closeTimer) {
      window.clearTimeout(closeTimer);
      closeTimer = 0;
    }
    syncPark();
    decorateOptionLayouts();
    decoratePrice();
    updateSheetMedia(selectedVariant());
    updateCustomSheetMedia();
    sheetOpen = true;
    setSupportHidden('product-sheet', true);
    sheet.hidden = false;
    if (overlay) overlay.hidden = false;
    document.body.classList.add('pq-mobile-buy-sheet-open');
    updateOffset();
    const reveal = () => {
      sheet.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
    };
    if (prefersReducedMotion()) {
      reveal();
    } else {
      requestAnimationFrame(() => requestAnimationFrame(reveal));
    }
    if (typeof trapFocus === 'function' && panel) {
      trapFocus(panel, panel.querySelector('.pq-mobile-buy-sheet__close') || panel);
    } else if (panel) {
      panel.focus();
    }
  };

  const barOpenLabel = () => {
    if (!isNativeBuy()) return 'Customize';
    return window.variantStrings?.addToCart || 'Add to cart';
  };

  const render = () => {
    const source = findSourceButton();

    if (source) {
      bar.hidden = false;
      setLoading(false);
      label.textContent = barOpenLabel();
      button.disabled = false;
    } else if (vueRoot && vueRoot.children.length) {
      bar.hidden = true;
      closeSheet();
    } else {
      bar.hidden = false;
      setLoading(true);
      button.disabled = true;
      label.textContent = '';
    }

    if (!mediaQuery.matches) closeSheet();
    host.classList.toggle('pq-native-buy', isNativeBuy());
    syncPark();
    decorateOptionLayouts();
    decoratePrice();
    syncQtyInputWidth();
    updateOffset();
  };

  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      render();
    });
  };

  button.addEventListener('click', () => {
    openSheet();
  });

  if (overlay) {
    overlay.addEventListener('click', () => closeSheet());
  }

  const sheetOptionZoom = (event) => {
    if (!mediaQuery.matches || !sheetOpen || !sheet) return null;
    const zoom = event.target.closest('.pq-mobile-buy-sheet .variant-selector .option button');
    if (!zoom || !sheet.contains(zoom)) return null;
    const hint = zoom.parentElement?.querySelector('img');
    const src = hint?.getAttribute('src');
    if (!src) return null;
    return { hint, src };
  };

  document.addEventListener(
    'pointerdown',
    (event) => {
      const zoom = sheetOptionZoom(event);
      if (!zoom || !window.PqMobilePreview) return;
      window.PqMobilePreview.warm(zoom.src);
    },
    { capture: true, passive: true }
  );

  document.addEventListener(
    'click',
    (event) => {
      const zoom = sheetOptionZoom(event);
      if (!zoom || !window.PqMobilePreview) return;
      event.preventDefault();
      event.stopPropagation();
      window.PqMobilePreview.open(zoom.src, zoom.hint);
    },
    true
  );

  if (sheet) {
    sheet.addEventListener('click', (event) => {
      if (event.target.closest('[data-pq-mobile-buy-sheet-dismiss]')) {
        closeSheet();
        return;
      }
      if (event.target.closest('.variant-selector .option')) {
        requestAnimationFrame(() => {
          updateCustomSheetMedia();
          requestAnimationFrame(updateCustomSheetMedia);
        });
        return;
      }
      if (event.target.closest('[data-pq-park-slot="vue-submit"] .product-form__submit')) {
        closeSheet();
      }
    });
  }

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !sheetOpen) return;
    if (document.querySelector('[data-pq-preview-dialog]:not([hidden])')) return;
    closeSheet();
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, (event) => {
      const target = event?.data?.event?.target || event?.data?.target;
      if (!target || !host.contains(target)) return;
      beginVariantPending();
    });
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      if (event?.data?.sectionId && event.data.sectionId !== host.dataset.section) return;
      updateSheetMedia(event?.data?.variant);
      decorateOptionLayouts();
      decoratePrice(event?.data?.variant);
      restoreOptionsScrollSoon();
      endVariantPending();
    });
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event?.source === 'product-form') closeSheet();
    });
  }

  new MutationObserver(schedule).observe(host, {
    attributes: true,
    attributeFilter: ['class', 'disabled', 'hidden'],
    characterData: true,
    childList: true,
    subtree: true,
  });

  if (optionsSlot) {
    optionsSlot.addEventListener(
      'change',
      () => {
        saveOptionsScroll();
      },
      true
    );
    new MutationObserver(pruneStalePickers).observe(optionsSlot, { childList: true });
  }

  if (qtySlot) {
    qtySlot.addEventListener('input', (event) => {
      if (!event.target.matches('.quantity__input')) return;
      fitQtyInput(event.target);
      applyPriceTotals();
    });
    qtySlot.addEventListener('change', (event) => {
      if (!event.target.matches('.quantity__input')) return;
      fitQtyInput(event.target);
      applyPriceTotals();
    });
  }

  const onViewportChange = () => {
    if (!mediaQuery.matches) closeSheet();
    syncProductModalSupport();
    schedule();
  };

  if (mediaQuery.addEventListener) {
    mediaQuery.addEventListener('change', onViewportChange);
  } else {
    mediaQuery.addListener(onViewportChange);
  }

  if (window.ResizeObserver) {
    new ResizeObserver(updateOffset).observe(bar);
  } else {
    window.addEventListener('resize', updateOffset);
  }

  new MutationObserver(syncProductModalSupport).observe(document.body, {
    attributes: true,
    attributeFilter: ['open'],
    subtree: true,
  });

  render();
  syncProductModalSupport();
})();

(() => {
  const host = document.querySelector('product-info:not([id*="quickadd"])');
  const root = host && host.querySelector('.product__description');
  const clip = root && root.querySelector('.product__description-clip');
  const body = root && root.querySelector('.product__description-body');
  const toggle = root && root.querySelector('.product__description-toggle');
  if (!host || !root || !clip || !body || !toggle) return;

  const mediaQuery = window.matchMedia('(max-width: 749px)');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let animating = false;
  let timer = 0;

  const lineHeightOf = () => {
    const sample = body.querySelector('p, li, h1, h2, h3, h4, h5, h6') || body;
    const style = window.getComputedStyle(sample);
    const parsed = parseFloat(style.lineHeight);
    if (style.lineHeight === 'normal' || Number.isNaN(parsed)) {
      return parseFloat(style.fontSize) * 1.5;
    }
    return parsed;
  };

  const applyLineSize = () => {
    clip.style.setProperty('--pq-desc-line', `${lineHeightOf()}px`);
  };

  const heightToLine = (lineCount) => {
    const range = document.createRange();
    const walker = document.createTreeWalker(body, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        return node.textContent && node.textContent.trim() ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      },
    });
    const top = body.getBoundingClientRect().top;
    let lines = 0;
    let lastBottom = 0;
    let prevBottom = -1;

    while (walker.nextNode()) {
      range.selectNodeContents(walker.currentNode);
      const rects = range.getClientRects();
      for (let i = 0; i < rects.length; i += 1) {
        const rect = rects[i];
        if (rect.width < 1 || rect.height < 1) continue;
        if (prevBottom < 0 || rect.top > prevBottom - 1) {
          lines += 1;
          prevBottom = rect.bottom;
        } else {
          prevBottom = Math.max(prevBottom, rect.bottom);
        }
        lastBottom = Math.max(lastBottom, rect.bottom);
        if (lines >= lineCount) {
          return Math.ceil(lastBottom - top);
        }
      }
    }

    return Math.ceil(body.scrollHeight);
  };

  const collapsedHeight = () => heightToLine(3) || lineHeightOf() * 3;

  const measureFull = () => {
    const prev = clip.style.height;
    clip.style.height = 'auto';
    const full = clip.scrollHeight;
    clip.style.height = prev;
    return full;
  };

  const setExpanded = (expanded, animate) => {
    root.classList.toggle('is-expanded', expanded);
    toggle.setAttribute('aria-expanded', String(expanded));
    toggle.setAttribute('aria-label', expanded ? toggle.dataset.labelLess : toggle.dataset.labelMore);

    if (!mediaQuery.matches || !root.classList.contains('is-collapsible')) {
      clip.style.height = '';
      return;
    }

    applyLineSize();
    const end = expanded ? measureFull() : collapsedHeight();
    if (!animate || reduceMotion.matches) {
      clip.style.height = `${end}px`;
      return;
    }

    const start = clip.getBoundingClientRect().height;
    animating = true;
    clip.style.height = `${start}px`;
    clip.offsetHeight;
    clip.style.height = `${end}px`;

    const onEnd = (event) => {
      if (event.propertyName && event.propertyName !== 'height') return;
      clip.removeEventListener('transitionend', onEnd);
      animating = false;
      if (expanded && root.classList.contains('is-expanded')) {
        clip.style.height = 'auto';
      }
    };
    clip.addEventListener('transitionend', onEnd);
  };

  const sync = () => {
    if (!mediaQuery.matches) {
      root.classList.remove('is-collapsible', 'is-expanded');
      toggle.hidden = true;
      clip.style.height = '';
      clip.style.removeProperty('--pq-desc-line');
      return;
    }

    applyLineSize();
    const wasExpanded = root.classList.contains('is-expanded');
    const limit = collapsedHeight();
    const needsClamp = body.scrollHeight > limit + 1;
    root.classList.toggle('is-collapsible', needsClamp);
    toggle.hidden = !needsClamp;

    if (!needsClamp) {
      root.classList.remove('is-expanded');
      clip.style.height = '';
      toggle.setAttribute('aria-expanded', 'false');
      return;
    }

    setExpanded(wasExpanded, false);
  };

  const schedule = () => {
    if (animating) return;
    window.clearTimeout(timer);
    timer = window.setTimeout(sync, 80);
  };

  toggle.addEventListener('click', () => {
    if (animating) return;
    setExpanded(!root.classList.contains('is-expanded'), true);
  });

  sync();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(sync).catch(() => {});
  body.querySelectorAll('img').forEach((img) => {
    if (!img.complete) img.addEventListener('load', schedule);
  });

  if (mediaQuery.addEventListener) {
    mediaQuery.addEventListener('change', sync);
  } else {
    mediaQuery.addListener(sync);
  }

  if (window.ResizeObserver) {
    let lastWidth = root.getBoundingClientRect().width;
    new ResizeObserver((entries) => {
      const width = entries[0] && entries[0].contentRect.width;
      if (width == null || Math.abs(width - lastWidth) < 1) return;
      lastWidth = width;
      schedule();
    }).observe(root);
  } else {
    window.addEventListener('resize', schedule);
  }
})();
